import { render, staticRenderFns } from "./ObjectPropertiesUpdate.vue?vue&type=template&id=29784621&scoped=true&"
import script from "./ObjectPropertiesUpdate.vue?vue&type=script&lang=js&"
export * from "./ObjectPropertiesUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ObjectPropertiesUpdate.vue?vue&type=style&index=0&id=29784621&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29784621",
  null
  
)

export default component.exports